import { render, staticRenderFns } from "./category-view-page.vue?vue&type=template&id=f36b4724&"
import script from "./category-view-page.vue?vue&type=script&lang=js&"
export * from "./category-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports